import { render } from "./InfractionDetails.vue?vue&type=template&id=5b58bebb&scoped=true"
import script from "./InfractionDetails.vue?vue&type=script&lang=js"
export * from "./InfractionDetails.vue?vue&type=script&lang=js"

import "./InfractionDetails.vue?vue&type=style&index=0&id=5b58bebb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b58bebb"]])

export default __exports__